<template>
  <div class="app-container news-detail">
    <basic-container>
      <el-tabs v-model="activeName">
        <el-tab-pane label="来源详情" name="first">

        <div v-if="!dialogEditVisible">
          <div class="news-detail-title">
            <el-button size="medium" type="primary" class="news-detail-title-button"
                    icon="el-icon-edit"
                    @click="handleUpdate(sourceDetail)">编辑</el-button>
          </div>
          <div class="news-detail-first">
            <el-row class="news-detail-item">
              <el-col :span="2" class="head">ID:</el-col>
              <el-col :span="16">{{ sourceDetail.id }}</el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">来源名称:</el-col>
              <el-col :span="16">{{ sourceDetail.name }}</el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">来源类型:</el-col>
              <el-col :span="16">{{ sourceDetail.sourceType }}</el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">爬取状态:</el-col>
              <el-col :span="16">{{ sourceDetail.activeStatus }}</el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">展示结果:</el-col>
              <el-col :span="16">{{ sourceDetail.displayStatus }}</el-col>
            </el-row>
            <el-row class="news-detail-item">
              <el-col :span="2">配置:</el-col>
              <el-col :span="16">{{ sourceDetail.settings }}</el-col>
            </el-row>
          </div>
        </div>

        <div v-if="dialogEditVisible">
          <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="80px">
            <el-form-item>
                <el-button type="primary" class="news-detail-dialog-publish-save"
                @click="handleEditSave('editForm')">保存</el-button>
                <el-button class="news-detail-dialog-publish-cancel"
                @click="cancelEdit('editForm')">取消</el-button>
            </el-form-item>
            <el-form-item label="爬取状态" prop="isActive" class="news-detail-dialog-item">
              <el-select v-model="editForm.isActive" placeholder="请选择">
                <el-option
                    v-for="item in activeStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
             </el-select>
            </el-form-item>
            <el-form-item label="展示结果" prop="isDisplay" class="news-detail-dialog-item">
              <el-select v-model="editForm.isDisplay" placeholder="请选择">
                <el-option
                  v-for="item in displayStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="配置" prop="settings" class="news-detail-dialog-title">
                <el-input type="textarea" :rows="8" v-model="editForm.settings">
                </el-input>
            </el-form-item>
          </el-form>
        </div>
        </el-tab-pane>
      </el-tabs>
    </basic-container>
  </div>
</template>

<script>
  import { getSource, updateSource } from '@/api/news/source'
  import { mapGetters } from 'vuex'

  const initDetail = vm => {
    // TODO hasDeletedSource
    getSource(vm.id).then(response => {
      let data = response.data
      if (response.status == 200) {
        formatNewsDetail(vm, vm.sourceDetail, data.data)
        if (vm.$route.query.edit == 'true') {
          vm.handleUpdate(vm.sourceDetail)
        }
      } else {
        vm.$message({
          showClose: true,
          message: '无法查看该来源详情',
          type: 'error'
        })
      }
    }).catch(error => {
      vm.$message({
        message: '获取来源详情失败',
        type: 'error'
      })
    })
  }

  const formatNewsDetail = (vm, detail, data) => {
    // 资讯详情格式化
    if (data) {
      // 获取资讯基本资料
      detail.id = data.id
      if (!data.name || data.name.length == 0) { detail.name = "--" }
      else { detail.name = data.name }

      if (data.isActive == 1) { 
        detail.isActive = 1
        detail.activeStatus = "开启"
      } else { 
        detail.isActive = 0
        detail.activeStatus = "关闭"
      }
      if (data.isDisplay == 1) { 
        detail.isDisplay = 1
        detail.displayStatus = "是" 
      } else { 
        detail.isDisplay = 0
        detail.displayStatus = "否"
      }

      if (data.type == 1) {
        detail.sourceType = "网站"
      } else if (data.type == 2) {
        detail.sourceType = "微信公众号"
      } else if (data.type == 3) {
        detail.sourceType = "微博"
      } else if (data.type == 4) {
        detail.sourceType = "其它"
      } else {
        detail.sourceType = "--"
      }
      detail.type = data.type
      detail.settings = data.settings

    }
  }

  export default {
    data () {
      return {
        // 查看详情窗口
        activeName: "first",
        sourceDetail:{
          id: null,
          name: "",
          type: "",
          isActive: null,
          isDisplay: null,
          settings: "",
          sourceType: "",
          activeStatus: "",
          displayStatus: ""
        },
        // 编辑窗口
        dialogEditVisible: false,
        editForm: {
          id: null,
          settings: null,
          isActive: null,
          isDisplay: null
        },
        displayStatusOptions: [
          { label: '否', value: 0 },
          { label: '是', value: 1 }
        ],
        activeStatusOptions: [
          { label: '关闭', value: 0 },
          { label: '开启', value: 1 }
        ],
        editRules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur'}
          ],
          isBanned: [
            { required: true, message: '请选择状态', trigger: 'blur'}
          ]
        },

      }
    },
    watch: {
      $route () {
        this.id = this.$route.params.id
        initDetail(this)
      }
    },
    mounted () {
      this.id = this.$route.params.id
      initDetail(this)
    },
    created() {

    },
    computed: {

    },
    methods: {
      handleUpdate(row) {
        // 资讯详情-编辑按键会调取此方法
        let _this = this
        this.editForm = {
          id: row.id,
          settings: row.settings,
          isActive: row.isActive,
          isDisplay: row.isDisplay
        }

        this.dialogEditVisible = true

        if (this.$refs['editForm']) {
          this.$refs['editForm'].resetFields();
        }
      },
      handleEditSave(formName) {
        // 编辑详情dialog-保存按键会调取此方法
        let _this = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let source = {
              id: _this.editForm.id,
              settings: _this.editForm.settings,
              isActive: _this.editForm.isActive,
              isDisplay: _this.editForm.isDisplay
            }
            updateSource(source).then(response => {
              let code = response.status
              if (code == 200) {
                this.dialogEditVisible = false
                _this.$message({
                  showClose: true,
                  message: '编辑成功',
                  type: 'success'
                })
                _this.$route.query.edit = false
                initDetail(_this)
              } else {
                _this.$message({
                  showClose: true,
                  message: '编辑失败',
                  type: 'error'
                })
              }
            }).catch(function () {
              _this.$message({
                showClose: true,
                message: '编辑失败',
                type: 'error'
              })
            })
          }
        })
      },
      cancelEdit(formName) {
        // 编辑详情dialog-取消按键会调取此方法
        this.dialogEditVisible = false
        this.editForm = {
          id: null,
          settings: null,
          isActive: null,
          isDisplay: null
        }
      },

    }
  }

</script>

<style lang="scss" scoped>
.news-detail {
  .news-detail-item {
    font-size: 16px;
    margin: 10px 0;
  }
  .news-detail-title {
    margin-top: 40px;
    &-button {
      position: absolute;
      right: 2px;
      top: 5px;
      padding: 8px 12px;
    }
  }
  .news-detail-source {
    margin-top: 7px;
    max-height: 400px;
    overflow: auto;
  }
  .news-detail-source-title {
    margin-right: 5px;
    &-button {
      float: right;
      margin-top: -7px;
      padding: 8px 12px;
    }
  }
  .news-detail-dialog {
    &-publish-save {
      padding: 8px 12px;
      float: right;
    }
    &-publish-cancel {
      padding: 8px 12px;
      float: right;
      margin-right: 10px;
    }
    &-title {
      width: 600px;
    }
    &-item {
      width: 500px;
    }
    &-summary {
      width: 1075px;
    }
  }
}
</style>
